export const isSmartPhone = (): boolean =>
  window.matchMedia && window.matchMedia("(max-device-width: 640px)").matches;

export function removeTrailingNumbers(str: string): string {
  // 文字列の後ろから1文字ずつ取り出して、数字だったら削除する
  while (/[0-9]/.test(str.slice(-1))) {
    str = str.slice(0, -1);
  }

  return str;
}

// REST APIのResponseヘッダと１ページ当たりの投稿数(perpage)から最大のページ数を取得
export const getMaxPageFromResponse = (
  response: Response,
  perPage: number
): number => Math.ceil(Number(response.headers.get("X-WP-Total")) / perPage);

// "2022-12-02T16:57:57"の形式を"2022-12-02"に変換する
export const convertDateStringToJp = (dateStr: string): string => {
  const [year, month, day] = new Date(dateStr)
    .toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/");
  return `${year}-${month}-${day}`;
};
